require('styles/common/util.scss');
require('styles/common/common1.scss');
require('plugins/Font-Awesome/css/all.min.css');
require('plugins/flexslider/flexslider.css');
require('plugins/slide/index.css');
require('plugins/slide/slide.css');
require('plugins/slick-carousel/slick/slick.css');
require('plugins/swiper/dist/css/swiper.min.css');
require('styles/pages/zhaoshang.scss');

require('script!jquery');
require('../common/form-validation.coffee');
require('script!sweetAlert');
require('script!ajaxform');
require('script!affix');
require('script!flexslider');
require('script!plugins/slide/slide.min.js');
require('script!plugins/swiper/dist/js/swiper.jquery.js');
require('../common/city.coffee');
// require('../common/side-bar.coffee');

"use strict";

new Swiper('#swiper1', {
  autoplay: 3000,
  loop: true
});

var swiper = new Swiper('#swiper2', {
  autoplay: 3000,
  loop: false,
  prevButton: '#swiper2 .swiper-button-prev',
  nextButton: '#swiper2 .swiper-button-next',
  onInit: function (swiper) {
    "use strict";
    var index = swiper.activeIndex;
    $('.swiper-tabs .tab').eq(index).addClass('active').siblings().removeClass('active');
  },
  onSlideChangeStart: function (swiper) {
    "use strict";
    var index = swiper.activeIndex;
    $('.swiper-tabs .tab').eq(index).addClass('active').siblings().removeClass('active');
  }
});

$('.swiper-tabs .tab').click(function () {
  "use strict";
  var index = $(this).index();
  swiper.slideTo(index);
});

$('.popup .close-btn').click(function () {
  "use strict";
  $('.popup').hide();
});

$('#slide3d1').slideCarsousel({
  slideType:'3d',
  indicatorEvent:'mouseover',
  interval:3000,
  autoPlay: 2500,
});

$(function () {
  "use strict";
  var $yuyuefix = $('.yuyuefix');
  var $yuyuefix_show = $('.yuyuefix_show');
  var $yuyuefix_close = $yuyuefix.find('.fix_close');
  $yuyuefix.addClass('affix_show');

  $yuyuefix_show.on('click', function(evt){
    evt.preventDefault();
    var $me = $(this);
    var showIsActive = $me.hasClass('active');
    if (showIsActive) {
      $yuyuefix.addClass('affix_show');
      $me.removeClass('active');
    }
  });

  $yuyuefix_close.on('click', function (evt) {
    evt.preventDefault();
    var fixIsActive = $yuyuefix.hasClass('affix_show');
    var showIsActive = $yuyuefix_show.hasClass('active');
    if (fixIsActive && !showIsActive) {
      $yuyuefix.attr('class','yuyuefix');
      $yuyuefix_show.addClass('active');
    }
  });

  $('.zhaoshang-btn').click(function (evt) {
    evt.preventDefault();
    var showIsActive = $yuyuefix_show.hasClass('active');
    if (showIsActive) {
      $yuyuefix.addClass('affix_show');
      $yuyuefix_show.removeClass('active');
    }
  });
});

$(function() {
  "use strict";

  var $forms = $("main form");
  $forms.each(function(inde, form) {
    var $form = $(form);

    $form.validate({
      errorPlacement: function(error) {
        return swal({
          title: error[0].innerHTML,
          allowOutsideClick: false
        });
      },
      submitHandler: function(form) {
        var phoneNumber, userId;
        phoneNumber = form.elements.mobile.value.trim();
        userId = "MOBI" + phoneNumber + "}";

        $(form).ajaxSubmit({
          dataType: "json",
          data: {
            rnd: parseInt(Math.random() * 1e7, 10) + new Date().getTime()
          },
          error: function() {
            return swal({
              title: "对不起，出错了，请稍后重试！",
              allowOutsideClick: true
            });
          },
          success: function(res) {
            if (res.msg && res.msg[0] && res.msg[0].type === "success") {
              swal({
                type: "success",
                title: '预约成功，稍后会有家装顾问与您联系，请注意电话',
                allowOutsideClick: true
              });
              // swal({
              //   customClass: "alert-success",
              //   title:
              //     '<img class="form_success" src="' +
              //     $("#alertImg").attr("src") +
              //     '" alt="">',
              //   confirmButtonText: "返  回",
              //   confirmButtonColor: "#3b9bff",
              //   allowOutsideClick: true,
              //   html: true
              // });
            }
            if (res.msg[0].type === "error") {
              swal({
                title: res.msg[0].info,
                allowOutsideClick: true
              });
              return false;
            }
            if (res.msg[0].type === "error") {
              swal({
                title: res.msg[0].info,
                allowOutsideClick: true
              });
              return false;
            }
          }
        });
      }
    });

    var elements = form.elements;
    // var effectives = [];

    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      var name = $(element).attr("name");
      if (name) {
        // effectives.push(element);
        var $elm = $(element);
        $elm.rules("add", {
          // required: Boolean($elm.attr('required')),
          mobileNum: Boolean($elm.attr("mobile")),
          messages: {
            required: $elm.data("required"),
            mobileNum: $elm.data("mobile")
          }
        });
      }
    }
  });
});


/*****************
 ** WEBPACK FOOTER
 ** ./zhaoshang.js
 ** module id = 0
 ** module chunks = 11
 **/